interface ProgramPlanProps {
  value: string;
  editable?: boolean;
  draft?: string;
  dirty?: boolean;
  saving?: boolean;
  status?: string | null;
  error?: string | null;
  onChange?: (value: string) => void;
  onSave?: () => void;
}

const ProgramPlan: React.FC<ProgramPlanProps> = ({
  value,
  editable = false,
  draft = value,
  dirty = false,
  saving = false,
  status,
  error,
  onChange,
  onSave,
}) => (
  <section className="space-y-3">
    <label htmlFor="program-plan" className="block text-sm font-semibold text-gray-900">Program Plan</label>
    {editable ? (
      <>
        <textarea
          id="program-plan"
          value={draft}
          onChange={(event) => onChange?.(event.target.value)}
          rows={8}
          className="block w-full rounded border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-mainBlue focus:outline-none focus:ring-2 focus:ring-mainBlue/20"
        />
        <div className="flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={onSave}
            disabled={saving || !dirty}
            className="min-h-[44px] rounded bg-mainBlue px-4 py-2 text-sm font-medium text-white hover:bg-mainBlue/90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
          {dirty && <span className="text-sm text-amber-700">Unsaved changes</span>}
          {status && <span role="status" className="text-sm text-green-700">{status}</span>}
        </div>
      </>
    ) : (
      <p className="whitespace-pre-line text-sm leading-relaxed text-gray-700">
        {value || 'Your instructor will add a program plan here.'}
      </p>
    )}
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
  </section>
);

export default ProgramPlan;